"use client";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
import { getColor, getContrastColor, getContainedHoverColor } from "../../../components/atoms/IconButton/IconButton.utils.js";
import styled from "../../../client-utils/styled/styled.js";
import IconAtom from "../../../components/atoms/Icon/index.js";
import IconButton from "@mui/material/IconButton";
const coreComponentName = "SdbIconButton";
export const Icon = styled(IconAtom, {
    name: coreComponentName,
    slot: "Icon",
    shouldForwardProp: shouldForwardProp("variant", "iconColor"),
})(({ theme, variant, iconColor }) => ({
    color: iconColor ? getColor({ theme, color: iconColor }) : theme.vars.palette.surface.onVariant,
    ...(variant === "contained" && {
        color: getContrastColor({ theme, color: iconColor }),
    }),
    ...(variant === "text" && {
        color: iconColor
            ? iconColor === "default"
                ? theme.vars.palette.surface.on
                : getColor({ theme, color: iconColor })
            : theme.vars.palette.surface.onVariant,
    }),
}));
export const Root = styled(IconButton, {
    name: coreComponentName,
    slot: "Root",
    shouldForwardProp: shouldForwardProp("variant", "color"),
})(({ theme, variant, color, disabled }) => ({
    ...(variant === "contained" && {
        backgroundColor: getColor({ theme, color }),
        "&:hover": {
            backgroundColor: getContainedHoverColor({ theme, color }),
        },
        ...(disabled && {
            backgroundColor: `${theme.vars.palette.action.disabledBackground} !important`,
            "& > *": {
                color: `${theme.vars.palette.action.disabled} !important`,
            },
            "&:hover": {
                backgroundColor: `${theme.vars.palette.action.disabledBackground} !important`,
            },
        }),
    }),
    ...(variant === "outlined" && {
        borderWidth: "thin",
        borderStyle: "solid",
        borderColor: color ? getColor({ theme, color }) : theme.vars.palette.surface.onVariant,
        transition: theme.transitions.create(["background-color", "border-color"], {
            duration: theme.transitions.duration.short,
        }),
        ...(disabled && {
            borderColor: `${theme.vars.palette.action.disabled} !important`,
            "& > *": {
                color: `${theme.vars.palette.action.disabled} !important`,
            },
            "&:hover": {
                borderColor: `${theme.vars.palette.action.disabled} !important`,
            },
        }),
    }),
    ...(disabled && {
        cursor: "not-allowed",
        pointerEvents: "none",
        ...(variant === "text" && {
            "& > *": {
                color: `${theme.vars.palette.action.disabled} !important`,
            },
        }),
    }),
}));
